import { render, staticRenderFns } from "./ImportarValProductos.vue?vue&type=template&id=45a8024a&"
import script from "./ImportarValProductos.vue?vue&type=script&lang=js&"
export * from "./ImportarValProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports